import './styles.sass';

import React from 'react';
import Transition from 'components/Explorer/Transition';
import { Link } from 'react-router-dom';

import LatestMention from './LatestMention';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const LatestMentions = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/latest_mentions', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const hasResults = Array.isArray(data) && data.length > 0;

  const content = () => {
    if (loading === Loading.ERROR) {
      return <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>;
    }
    return (
      <div key="content" className="Highlights-content Highlights-LatestMentions-content">
        {hasResults ? (
          data.map((post) => <LatestMention key={`mention-${post.id}`} post={post} />)
        ) : (
          <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.LatestMentions.empty')}</div>
        )}
      </div>
    );
  };

  return (
    <div className="Highlights-LatestMentions Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.LatestMentions.title')}</h2>
      <div className="Highlights-content-wrapper">
        <Transition>{isLoading ? <div className="Highlights-loading-message" /> : content()}</Transition>
        {hasResults && (
          <Link
            onClick={() => Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'latest-mentions' })}
            to={QueryParams.locationFor(params, '/mentions')}
            className="Highlights-jump-link"
            aria-label={
              I18n.t('Explorer.Highlights.LatestMentions.title') +
              ' — ' +
              I18n.t('Explorer.Highlights.LatestMentions.more')
            }
          >
            {I18n.t('Explorer.Highlights.LatestMentions.more')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default LatestMentions;
